import { Col } from "@commonlibs";
import styled, { css } from "styled-components";
import Header from "ui/common/components/navigation/Header/Header";

export const InnerCardNavigationRoot = styled(Col)(
    ({ theme }) => css`
        position: relative;
        height: 100%;
        --card-navigation-header-height: 4.25rem;
        --card-navigation-x-padding: ${theme.spacing[5]};
        --card-navigation-padding-bottom: ${theme.spacing[8]};
    `,
);

export const InnerCardNavigationHeader = styled(Header)(
    () => css`
        min-height: 4.25rem;
    `,
);

export const InnerCardNavigationHeaderWrapper = styled(Col)(
    ({ theme }) => css`
        position: absolute;
        width: 100%;
        top: 0;
        z-index: ${theme.zIndex.header};
        background: ${theme.palette.background};
        border-radius: ${theme.borderRadius};
    `,
);

export const InnerCardNavigationBody = styled.div(
    () => css`
        margin-top: var(--card-navigation-header-height);
        padding: var(--card-navigation-x-padding);
        padding-bottom: var(--card-navigation-padding-bottom);
        height: 100%;
        max-height: calc(100% - var(--card-navigation-header-height));
        overflow-y: auto;
    `,
);
